import $ from 'jquery';

export const init = () => {

	var $links = $('.m-main--fixed .m-main__link, .m-detail--fixed .m-detail__link');

	// Click
	$links
		.on('click', function(e) {
			e.preventDefault();

      if ($(window).width() > 750) {
          $('body, html').animate({
              scrollTop: $(this.hash).offset().top - $('.b-fixed').outerHeight() - 16,
          }, 500);
      } else {
          $('body, html').animate({
              scrollTop: $(this.hash).offset().top,
          }, 500);
      }

      /*
			if($(window).width() > 750) {
				$('body, html').animate({
					scrollTop: $( $(this).attr('href') ).offset().top - $('.b-fixed').outerHeight() - 16,
				}, 500);
			}else {
				$('body, html').animate({
					scrollTop: $( $(this).attr('href') ).offset().top,
				}, 500);
			}
      */

		});

	// Anchors corresponding to menu items
	var $items = $links.map(function() {
		var item = $( $(this).attr('href') );
		if ( item.length ) {
			return item;
		}
	});

	$(window).on('scroll', function() {

		// Get container scroll position
		var fromTop = $(this).scrollTop();

		// Get id of current scroll item
		var cur = $items.map(function() {
			if ( $(this).offset().top + $(this).outerHeight() - $('.b-fixed').outerHeight() >= fromTop ) {
				return this;
			}
		});

		// Get the id of the current element
		// cur = cur[cur.length-1];
		var id = cur && cur.length ? cur[0].attr('id') : '';

		// Set/remove active class
		$links.addClass('is-active');
		$('.m-detail__item').has('.m-detail__link[href="#' + id + '"]').find('.m-detail__link').removeClass('is-active');
		$('.m-detail__item').has('.m-detail__link[href="#' + id + '"]').find('~ .m-detail__item').find('.m-detail__link').removeClass('is-active');
	});

	$(window).trigger('scroll');
};
